export const environment = {
  production: false,
  api: 'https://api.dev.coreact.gr/api/',
  hub: 'https://api.dev.coreact.gr',
  reportUrl: 'https://reports.api.dev.coreact.gr/',
  showEthnikiLogo: false,
};
